/**
 * AddDRMAccountCtrl controller
 * Add/edit DRM Account
 */

import { DRM_ACCOUNT_TYPES, DRM_ACCOUNT_TYPES_LABELS, DRM_PROFILE_TYPES } from 'app/core/constants'

// controller mixins
AddDRMAccountCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * AddDRMAccountCtrl controller
 *
 * @class AddDRMAccountCtrl
 * @memberof mwApp/drm
 * @see mwApp/drm
 *
 * @ngdoc controller
 * @name mwApp/drm.controller:AddDRMAccountCtrl
 */
/* @ngInject */
export default function AddDRMAccountCtrl ($scope, $uibModal, account, DRMProfile) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = false

  /**
   * DRM Account types
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @type {{}}
   */
  vm.drm_account_keys = Object.keys(DRM_ACCOUNT_TYPES).map((key) => DRM_ACCOUNT_TYPES[key])
  vm.drm_account_types = DRM_ACCOUNT_TYPES
  /**
   * DRM Account labels of types
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @type {{}}
   */
  vm.drm_account_types_labels = DRM_ACCOUNT_TYPES_LABELS

  /**
   * DRM Profile drm types
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @type {{}}
   */
  vm.drm_profle_types = DRM_PROFILE_TYPES

  /**
   * DRM Account
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @type {models.DRMAccount}
   */
  vm.account = account

  /**
   * DRM Profiles list
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @type {models.DRMProfile[]}
   */
  vm.profiles = []

  /**
   * isNew flag
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @type {Boolean}
   */
  vm.isNew = account._isNew()

  /**
   * Create/update DRM Account
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   */
  vm.save = function () {
    vm.setDisable()

    account._save()
      .then(vm.location(account).reload)
      .finally(vm.unsetDisable)
  }

  /**
   * Delete DRM Account
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   */
  vm.delete = function () {
    vm.setDisable()

    account._delete()
      .then(vm.location(account).list)
      .finally(vm.unsetDisable)
  }

  /**
   * Get DRM Profiles by account from backend
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   * @param {Object} tableState - smart table state object
   */
  vm.getDRMProfiles = function (tableState) {
    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    DRMProfile.loadSmart(tableState, { drmAccountId: account.id })
      .then(
        data => {
          vm.profiles = data.content.map((c) => {
            c.drmAccountId = account.id
            return c
          })
          vm.isFound = !!vm.profiles.length

          $scope.loading = false
        }
      )
  }

  /**
   * Create profile
   *
   * @memberof mwApp/drm.controller:CatchupCtrl
   * @function
   * @param  {models.DRMProfile} profile
   * @param {Event} $event - jqLite event object
   */
  vm.addProfile = vm.editProfile = function (profile, $event) {
    vm.stopEvent($event)

    var isNew = !profile
    $uibModal.open({
      templateUrl: 'components/drm/views/addDRMProfile.html',
      controller: 'AddDRMProfileCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        profile: function () {
          return !isNew
            ? DRMProfile.load(profile) // load
            : new DRMProfile({ drmAccountId: account.id })
        },
        providerType: function () { return account.type }
      }
    }).result
      .then(() => $scope.$broadcast('refreshTable'))
  }

  /**
   * Delete DRM Profile
   *
   * @memberof mwApp/drm.controller:AddDRMAccountCtrl
   */
  vm.deleteProfile = function (profile) {
    vm.setDisable()

    profile._delete()
    // .then(vm.location(profile).list)
      .then(() => $scope.$broadcast('refreshTable'))
      .finally(vm.unsetDisable)
  }
}
